import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SlugControlState } from "./slugControl.state";
import { checkSlug } from "./slugControl.thunk";
import { SlugControlResponse } from "./slugControl.types";

const initialState: SlugControlState = {
  data: null,
  error: null,
  status: "idle",
  lastCheckedSlug: null,
};

const slugControlSlice = createSlice({
  name: "slugControl",
  initialState,
  reducers: {
    clearSlugControl: (state) => {
      state.data = null;
      state.error = null;
      state.status = "idle";
      state.lastCheckedSlug = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (build) => {
    build
      .addCase(checkSlug.pending, (state, action) => {
        state.status = "loading";
        state.error = null;
        // Request slug'unu kullan, response slug'unu değil
        state.lastCheckedSlug = action.meta.arg.slug;
      })
      .addCase(
        checkSlug.fulfilled,
        (state, action: PayloadAction<SlugControlResponse>) => {
          state.status = "success";
          state.data = action.payload;
          // lastCheckedSlug zaten pending'de set edildi
        },
      )
      .addCase(
        checkSlug.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Bir hata oluştu.";
        },
      );
  },
});

export const { clearSlugControl, clearError } = slugControlSlice.actions;
export default slugControlSlice.reducer;